/**
 * Curated Lucide icon names for the bottom tab bar icon picker.
 *
 * All names must be valid keys in `lucide-react`'s `icons` export object.
 * Verified against lucide-react@0.554.0.
 */

/** Top 16 icons shown in the recommended grid (4×4). */
export const RECOMMENDED_ICONS = [
  'House',
  'Search',
  'ShoppingCart',
  'User',
  'LayoutGrid',
  'Heart',
  'Bell',
  'Settings',
  'MessageCircle',
  'Tag',
  'Gift',
  'MapPin',
  'Star',
  'Bookmark',
  'Percent',
  'Store',
] as const

/** Full curated set (~80 icons suitable for e-commerce tab bars). Includes recommended. */
export const ALL_TAB_ICONS = [
  // Recommended (first 16)
  ...RECOMMENDED_ICONS,
  // Shopping & commerce
  'Package',
  'Truck',
  'CreditCard',
  'Wallet',
  'Receipt',
  'BadgeCheck',
  // Analytics
  'ChartBar',
  'TrendingUp',
  // Time & scheduling
  'Clock',
  'Calendar',
  // Communication
  'Mail',
  'Phone',
  // Media
  'Camera',
  'Image',
  'FileText',
  // Organization
  'Folder',
  'List',
  'Grid2x2',
  'Layers',
  // Action
  'Zap',
  'Sparkles',
  'WandSparkles',
  // Achievement
  'Award',
  'Trophy',
  'Medal',
  'Crown',
  // Food & drink
  'Flame',
  'Coffee',
  'Pizza',
  'Utensils',
  'Wine',
  // Entertainment
  'Music',
  'Radio',
  'Headphones',
  // Devices
  'Monitor',
  'Smartphone',
  'Tablet',
  // Network
  'Wifi',
  'Globe',
  // Location
  'Map',
  'Navigation',
  'Compass',
  // Targeting
  'Target',
  'Crosshair',
  // Visual
  'Eye',
  'Lightbulb',
  // Tools
  'Puzzle',
  'Wrench',
  'Shield',
  'Lock',
  'Key',
  // Creative
  'Palette',
  'Paintbrush',
  'Scissors',
  'Ruler',
  'PenTool',
  // Text
  'Type',
  'Hash',
  'AtSign',
  // Social
  'ThumbsUp',
  'Smile',
  // Weather & nature
  'Sun',
  'Moon',
  'Cloud',
  'Umbrella',
  'Flower',
  'Leaf',
  'Trees',
] as const
